import {View} from '@fantasmagames/slot/src/common/view/View';

export interface ViewsMap {
	[name: string]: View;
}

export enum Layers {
	HIDDEN_LAYER = 0,
	BACKGROUND_LAYER,
	BEHIND_THE_REELS,
	LOGOTYPE_BACKGROUND_LAYER,
	REELS_LAYER,
	REELS_FRAME_LAYER,
	SYMBOLS_ANIMATIONS_LAYER,
	SYMBOLS_ANIMATIONS_LAYER_2,
	SYMBOLS_ANIMATIONS_LAYER_3,
	REELS_WIN_LAYER,
	STICKY_SYMBOLS_LAYER,
	WIN_LINES_LAYER,
	WIN_TEXT_LAYER,
	REEL_POPUP_LAYER,
	FOREGROUND_LAYER,
	KEYPAD_LAYER,
	OVER_KEYPAD_LAYER,
	BONUS_LAYER,
	MENU_LAYER,
	GUI_INFO_LAYER,
	POPUPS_LAYER,
	OVER_POPUP_LAYER,
	OVER_POPUP2_LAYER,
	OVER_POPUP3_LAYER,
	INFORMATION_POPUPS_LAYER,
	SYSTEM_POPUPS_LAYER,
	SCREEN_BLOCKER_LAYER,
	LOGOTYPE_LAYER,
	CHEATS_LAYER,
	TOTAL_LAYERS,
}

export interface ViewsZOrderMap {
	[name: string]: Layers;
}

export interface IViewsManager {
	getView(name: string): View;
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/common/view/_interfaces/IViewsManager.ts